import Page from './page';
import ProductGallery from '../components/product/product-gallery';
import PageHelper from '../helpers/page-helper';
import FileDocumentData from '../model/file-document-data';

const selectors = {
    container: '.js-productDetailsDocuments',
    filesTab: '.js-filesTab'
};

export default class ProductDetailsPage extends Page {

    private readonly container: JQuery;

    constructor(private body: HTMLBodyElement) {
        super();
        this.container = $(selectors.container);
        ProductGallery.initAll();
        this.bindVariantSelector();
        this.bindProductDocuments();
    }

    private bindVariantSelector(): void {
        const variantSelector = this.body.querySelector<HTMLSelectElement>('.js-productVariant');
        const quantitySelector = this.body.querySelector<HTMLInputElement>('.js-qty-selector-input') as HTMLInputElement;

        if (variantSelector) {
            variantSelector.addEventListener('change', () => {
                const productCode = variantSelector.value ?? '';
                PageHelper.showLoadingIndicator();
                window.location.href = `${window.ACC.config.encodedContextPath}/p/${productCode}?qty=${quantitySelector.value}`;
            });
        }
    }

    private bindProductDocuments() {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        ProductDetailsPage.getProductDocuments(this.container.data('product-code'))
            .done((data: FileDocumentData[]) => data.forEach((document): void => {
                if (data.length) {
                    $(selectors.filesTab).removeClass('d-none');
                    this.container.append(
                        $(`<li>
                        <a href="${window.ACC.config.encodedContextPath}/product/document/download?token=${document.fileDownloadJwt}"><i class="fas fa-download mr-5"></i>${document.id}</a>
                       </li>`)
                    );
                }
            }))
            .fail((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });
    }

    private static getProductDocuments(productCode: string): JQuery.jqXHR {
        return $.ajax({
            url: `${window.ACC.config.encodedContextPath}/documents/product/${productCode}`,
            method: 'GET'
        });
    }
}
